<!-- 对阵 -->
<template>
    <div class="">
     <div class="title">第1轮 对阵桌次表</div>
         <table>
             <thead>
                 <tr>
                 <th>桌号</th>
                 <th>东</th>
                 <th>西</th>
                 <th>南</th>
                 <th>北</th>
                 </tr>
             </thead>
             <tbody>    
                 <tr v-for="(item,index) in dataList" :key="index">
                 <td>{{item.deskNo}}</td>
                 <td  v-for="user in item.users" :key="user.id">{{ user.username }} -编号[{{user.id }}]</td>
                 </tr>  
             </tbody>
         </table>
    </div>
 </template>
 
 <script>
 export default {
     props:{
        pubId: {
             type: String,
             default: ''
         },
        pubType: {
            type: String,
            default: ''
        }
     },
     data() {
         return {
             dataList: [],
             tableData: [],
         }
     },
     created() {
 
     },
     mounted() {
         this.initData()
     },
     methods: {
         // 对阵查询
         initData(){
            let params = {
                 opcode: this.$code.PubEncounter,
                 i_serial_mark: this.pubId,
             }
             this.$api.requestAPI(params).then(res =>{
                 if (res.IsSuccess) {
                     let result = res.Data.DataTable
 
                     let arr  = result.map(item=>{
                         return{
                             deskNo: item['桌号'],
                             id: item['选手编号'],
                             username: item['选手名称'],
                             phone: item['选手手机号'],
                             company: item['协会（俱乐部）'],
                             userId: item['选手账号'],
                             seat: item['座位'],
                             round: item['第几轮']
                         }
                     })
                    //  console.log('对阵',arr)
                    //  this.dataList = this.selectDeskNo(arr)
                 }
             })
         },
         selectDeskNo(arr){
             let result = []
             arr.forEach(item => {
                 if(!result.some(i => i.deskNo === item.deskNo)){
                     result.push({
                         deskNo: item.deskNo,
                         users: arr.filter(user => user.deskNo === item.deskNo)
                     })
                 }
             });
             return result
         },
         submit(){
             let params = {
                 opcode: this.$code.PubArrangeSet,
                 i_serial_mark: this.pubId,
                 i_round: '',
                 i_desk_no: '',
                 v_seat: '',
                 i_players_number: '',
             }
             this.$api.requestAPI(params).then(res =>{
                 if (res.IsSuccess) {
                     let result = res.Data.DataTable
 
                     // this.tableData = result.map(item=>{
                     //     return{
                     //         index: item['序号'],
                     //         id: item['选手编号'],
                     //         username: item['选手名称'],
                     //         publishId: item['赛事标识'],
                     //         company: item['协会（俱乐部）'],
                     //         status: item['状态'],
                     //     }
                     // })
                 }
             })
         },
     }
 }
 </script>
 <style lang='scss' scoped>
 @import '@/assets/css/style.scss';
 .title{
     font-size: 30px;
     margin-bottom: 20px;
 }
 table {
     width: 100%;
     border-collapse: collapse;
   }
   th, td {
     border: 1px solid #999;
     padding: 8px;
     text-align: left;
     font-size: 28px;
   }
   tr:nth-child(even) {
     background-color: lightblue;
   }
   thead th {
     background-color: #f2f2f2;
     font-size: 30px;
     text-align: center;
   }
   .table-label {
     display: flex;
     justify-content: space-between;
     align-items: center;
     padding: 10px;
     background-color: #f9f9f9;
     border: 1px solid #ddd;
   }
 </style>


// WEBPACK FOOTER //
// src/views/team/components/encounter.vue